/**
 * Sticky horizontal section TOC + prev/next for Add/Edit user forms.
 */
import '../../styles/admin-user-form-nav.css';

export default function AdminUserFormSectionNav({
  sections = [],
  activeId,
  onSelect,
  onPrev,
  onNext,
  hasPrev,
  hasNext,
}) {
  if (!sections.length) return null;

  return (
    <nav
      className="auf-section-nav sticky top-0 z-20 mb-6 -mx-2 px-2 py-3 rounded-lg border"
      style={{
        backgroundColor: 'var(--color-surface)',
        borderColor: 'var(--color-border)',
        boxShadow: '0 8px 24px rgba(0,0,0,0.06)',
      }}
      aria-label="Form sections"
    >
      <div className="flex items-center gap-2 mb-2">
        <button
          type="button"
          onClick={onPrev}
          disabled={!hasPrev}
          className="px-3 py-1.5 text-sm rounded-md border disabled:opacity-40 transition-all duration-200"
          style={{
            borderColor: 'var(--color-border)',
            color: 'var(--color-text)',
            backgroundColor: 'var(--color-surface-secondary)',
          }}
        >
          Previous
        </button>
        <button
          type="button"
          onClick={onNext}
          disabled={!hasNext}
          className="px-3 py-1.5 text-sm rounded-md border disabled:opacity-40 transition-all duration-200"
          style={{
            borderColor: 'var(--color-border)',
            color: 'var(--color-text)',
            backgroundColor: 'var(--color-surface-secondary)',
          }}
        >
          Next section
        </button>
        <span className="text-xs theme-text-secondary ml-auto">
          {Math.max(1, sections.findIndex((s) => s.id === activeId) + 1)} / {sections.length}
        </span>
      </div>

      <div className="flex gap-2 overflow-x-auto pb-1 auf-section-nav-track">
        {sections.map((section, index) => {
          const active = section.id === activeId;
          return (
            <button
              key={section.id}
              type="button"
              onClick={() => onSelect(section.id)}
              className="auf-section-nav-chip shrink-0 px-3 py-1.5 rounded-full text-sm border transition-all duration-300 ease-out"
              style={{
                borderColor: active
                  ? 'var(--color-primary, #2563eb)'
                  : 'var(--color-border)',
                backgroundColor: active
                  ? 'var(--color-primary, #2563eb)'
                  : 'var(--color-surface-secondary)',
                color: active ? '#fff' : 'var(--color-text)',
                transform: active ? 'translateY(-1px) scale(1.03)' : 'none',
                boxShadow: active ? '0 4px 12px rgba(37,99,235,0.25)' : 'none',
              }}
              aria-current={active ? 'true' : undefined}
            >
              <span className="opacity-70 mr-1">{index + 1}.</span>
              {section.label}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
